<style lang='scss' scoped>
.myCloud {
  position: relative;
  overflow: hidden;
  min-height: 13rem;
  .selectType {
    .allLi {
      
      line-height: 0.8rem;
      color: #666666;
      display: inline-block;
      margin-right: 0.5rem;
      min-width: 0.5rem;
      max-width: 2.5rem;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      text-align: center;
      position: relative;
      font-size: 0.28rem;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;

    }
    .allLi-size-box{
      flex-shrink: 0;
      display: flex;
      padding-bottom: 8px;
      padding-top:6px;
      border-bottom: 1px solid #F3F4F6;
    }
    .allLi-size{
      flex-shrink: 0;
      color: #666666;
      display: inline-block;
      margin-right: 0.3rem;
      min-width: 0.5rem;
      max-width: 2.5rem;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      text-align: center;
      position: relative;
      font-size: 0.28rem;
      padding:2px 12px;
      background: #F5F7FA;
      border-radius: 20px;
      &.active {
        color: #3250CF;
        background-color: rgba(51, 77, 187, 0.1);
      }
    }
    .allLi.active {
      color: #3250CF;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      &::before{
        content:' ';
        position: absolute;
        top:0.7rem;
        height:2px;
        background-color: #3250CF;
        width:100%;
      }
    }
    & > div {
      width: 6.86rem;
      padding: 0px 0.32rem;
      white-space: nowrap;
      overflow: hidden;
    }
    .type-ul {
      height: 0.8rem;
      
      line-height: 0.8rem;
      width: 5.8rem;
      position: relative;
      overflow: scroll;
      -webkit-overflow-scrolling: touch;
      /*ios浏览器上隐藏滚动条无效，可以使用padding属性把滚动条定出范围,具体大小根据实际情况设定*/
      overflow-y: hidden;
      padding-bottom: 10px;
      &::-webkit-scrollbar, &::-webkit-scrollbar{width:0px;height:0px;}
      // .hiddenScroll{
      //   height:4px;
      //   width:100%;
      //   background-color: red;
      //   position: absolute;
      //   bottom: 4px;
      // }
      // &::-webkit-scrollbar {
      //   display: none;
      // }
      li {
        color: #666666;
        display: inline-block;
        margin-right: 0.5rem;
        min-width: 0.5rem;
        max-width: 2.5rem;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        text-align: center;
        font-size: 0.28rem;
        position: relative;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        
      }
      li.active {
      color: #3250CF;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
        &::before{
          content:' ';
          position: absolute;
          top:0.7rem;
          height:2px;
          background-color: #3250CF;
          width:100%;
        }
      }
    }

    .size-ul {
      width: 5.5rem;
      position: relative;
      overflow: scroll;
      -webkit-overflow-scrolling: touch;
      display: flex;
      /*ios浏览器上隐藏滚动条无效，可以使用padding属性把滚动条定出范围,具体大小根据实际情况设定*/
      overflow-y: hidden;
      flex-shrink:  0;
      &::-webkit-scrollbar, &::-webkit-scrollbar{width:0px;height:0px;}
      // .hiddenScroll{
      //   height:4px;
      //   width:100%;
      //   background-color: red;
      //   position: absolute;
      //   bottom: 4px;
      // }
      // &::-webkit-scrollbar {
      //   display: none;
      // }
      li {
        color: #666666;
        margin-right: 0.3rem;
        min-width: 0.5rem;
        flex-shrink: 0;
        max-width: 2.5rem;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        text-align: center;
        font-size: 0.28rem;
        position: relative;
        padding: 2px 12px;
        background: #F5F7FA;
        border-radius: 20px;
      }
      li.active {
        color: #3250CF;
        background-color: rgba(51, 77, 187, 0.1);
      }
    }
  }
  .codeData {
    padding-bottom: 2rem;
    li {
      margin-top: 0.3rem;
      margin-left: 3.46%;
      width: 44.26%;
      height: 4.18rem;
      border: 1px solid #e6e9ed;
      .img_box {
        // width: 87.95%;
        height: 2.48rem;
        line-height: 2.48rem;
        border-top-right-radius: 0.05rem;
        border-top-left-radius: 0.05rem;
        padding: 0.2rem;
        text-align: center;
        background-color: #e6e9ed;
        img {
          vertical-align: middle;
          border-radius: 0.1rem;
          max-width: 87.95%;
          max-height: 2.48rem;
        }
      }
      .codeInfo {
        padding: 0.2rem 0.32rem 0.24rem 0.32rem;
        p {
          font-size: 0.28rem;
          margin-bottom: 0.2rem;
        }
        div.m_clearLR {
          font-size: 0.24rem;
          line-height: 0.24rem;
          color: #9a9a9a;
        }
      }
    }
  }
  .noDataTextEmpty {
    position: absolute;
    width: 100%;
    text-align: center;
    margin-top: 0.5rem;
    color: #666;
    font-size: 0.28rem;
    z-index: 999;
    padding-bottom: 0.5rem;
    img {
      width: 1.99rem;
    }
    div {
      margin-top: 0.5rem;
    }
  }
  .selectSort {
    position: absolute;
    top: 0.74rem;
  }
  .noData {
    text-align: center;
    margin-top: 0.5rem;
    color: #666;
    font-size: 0.28rem;
    padding-bottom: 1.5rem;
  }
}
</style>
<template>
  <div class="myCloud">
    <!-- <div class='sort m_clearLR' @click="openSort">
      <div class="sort_boxL m_clearLR m_floatL">
        <img src="@/../public/images/small.png" alt="" class="">
        <div class="m_floatR">按名称排序</div>
      </div>
      <div class="sort_boxR m_clearLR m_floatR">
        <img src="@/../public/images/list.png" alt="" class="">
        <div class="m_floatR">大图</div>
      </div>
    </div>-->
    <!-- <selectSort class="selectSort" v-show="showSort" @selectSort='selectSort'></selectSort> -->
    <div class="selectType" v-show="!keywords">
      <div class="m_clearLR">
        <div
          class="m_floatL allLi"
          @click="selectCate(0)"
          :class="cateIndex==0?'active':''"
        >{{$route.query.type==1?'All':'全部'}}</div>
        <ul class="m_floatL type-ul">
          <li
            v-for="(item,_index) in cateData"
            :key="_index"
            @click="selectCate(_index+1)"
            :class="cateIndex==_index+1?'active':''"
          >{{$route.query.type==1?item.ename:$route.query.type==2?item.fname:item.name}}</li>
          <!-- <div class="hiddenScroll"></div> -->
        </ul>
      </div>
      <div class="m_clearLR allLi-size-box">
        <div
          class="m_floatL allLi-size"
          @click="selectSize(0)"
          :class="sizeIndex==0?'active':''"
        >{{_lang[this.$route.query.type].zhen_26}}</div>
        <ul class="size-ul">
          <li
            v-for="(item,_index) in sizeData"
            :key="_index"
            @click="selectSize(_index+1)"
            :class="sizeIndex==_index+1?'active':''"
          >{{item.name}}</li>
        </ul>
      </div>
    </div>
    <ul class="codeData m_clearLR">
      <li class="m_floatL" v-for="(item,index) in cloudData" :key="index" @click="selectTag(item)">
        <div class="img_box">
          <img :src="item.img" alt />
        </div>
        <div class="codeInfo">
          <p class="textLine">{{item.name}}</p>
          <div class="m_clearLR">
            <div class="size m_floatL">{{item.fileWidth+'X'+item.fileHeight}}</div>
          </div>
        </div>
      </li>
    </ul>
    <div class="noDataTextEmpty zhen_27" v-show="noDataTextEmpty">
      <img src="@/../public/images/noData.png" />
      <div>{{_lang[$route.query.type].zhen_5}}</div>
    </div>
    <div class="noData zhen_7">{{_lang[$route.query.type].zhen_5}}</div>
  </div>
</template>
<script>
import { lang } from '@/utils/i18n';
import selectSort from '@/components/selectSort';
// import CryptoJS from "crypto-js";
import JSEncrypt from 'jsencrypt';
import jsSha256 from 'js-sha256';
import { GetQueryString } from '@/../public/js/main.js';
import CryptoJS from 'crypto-js';
import { DlabelTemplate, TemplateCategory, getFileSize } from '@/api/api';
var bridge = {
  default: this,
  call: function (b, a, c) {
    var e = '';
    'function' == typeof a && ((c = a), (a = {}));
    a = { data: void 0 === a ? null : a };
    if ('function' == typeof c) {
      var g = 'dscb' + window.dscb++;
      window[g] = c;
      a._dscbstub = g;
    }
    a = JSON.stringify(a);
    if (window._dsbridge) e = _dsbridge.call(b, a);
    else if (window._dswk || -1 != navigator.userAgent.indexOf('_dsbridge'))
      e = prompt('_dsbridge=' + b, a);
    return JSON.parse(e || '{}').data;
  },
  register: function (b, a, c) {
    c = c ? window._dsaf : window._dsf;
    window._dsInit ||
      ((window._dsInit = !0),
      setTimeout(function () {
        bridge.call('_dsb.dsinit');
      }, 0));
    'object' == typeof a ? (c._obs[b] = a) : (c[b] = a);
  },
  registerAsyn: function (b, a) {
    this.register(b, a, !0);
  },
  hasNativeMethod: function (b, a) {
    return this.call('_dsb.hasNativeMethod', { name: b, type: a || 'all' });
  },
  disableJavascriptDialogBlock: function (b) {
    this.call('_dsb.disableJavascriptDialogBlock', { disable: !1 !== b });
  },
};
!(function () {
  if (!window._dsf) {
    var b = {
        _dsf: { _obs: {} },
        _dsaf: { _obs: {} },
        dscb: 0,
        dsBridge: bridge,
        close: function () {
          bridge.call('_dsb.closePage');
        },
        _handleMessageFromNative: function (a) {
          var e = JSON.parse(a.data),
            b = { id: a.callbackId, complete: !0 },
            c = this._dsf[a.method],
            d = this._dsaf[a.method],
            h = function (a, c) {
              b.data = a.apply(c, e);
              bridge.call('_dsb.returnValue', b);
            },
            k = function (a, c) {
              e.push(function (a, c) {
                b.data = a;
                b.complete = !1 !== c;
                bridge.call('_dsb.returnValue', b);
              });
              a.apply(c, e);
            };
          if (c) h(c, this._dsf);
          else if (d) k(d, this._dsaf);
          else if (((c = a.method.split('.')), !(2 > c.length))) {
            a = c.pop();
            var c = c.join('.'),
              d = this._dsf._obs,
              d = d[c] || {},
              f = d[a];
            f && 'function' == typeof f
              ? h(f, d)
              : ((d = this._dsaf._obs),
                (d = d[c] || {}),
                (f = d[a]) && 'function' == typeof f && k(f, d));
          }
        },
      },
      a;
    for (a in b) window[a] = b[a];
    bridge.register('_hasJavascriptMethod', function (a, b) {
      b = a.split('.');
      if (2 > b.length) return !(!_dsf[b] && !_dsaf[b]);
      a = b.pop();
      b = b.join('.');
      return (b = _dsf._obs[b] || _dsaf._obs[b]) && !!b[a];
    });
  }
})();
export default {
  data() {
    return {
      cateIndex: 0,
      sizeIndex: 0,
      showSort: false,
      page_size: 10,
      noData: false,
      tagTime: false,
      mac: 'daf3b950-27ee-4d',
      noDataTextEmpty: false,
      page: 1,
      allData: {},
      cloudData: [],
      loadingData: false,
      allList: [],
      allDataZh:{},
      allDataEn:{},
      cateData: [],
      sizeData: [
        { id: 8, name: '1~30', sizeMin: 0, sizeMax: 30, weight: 0 },
        { id: 9, name: '31~40', sizeMin: 31, sizeMax: 40, weight: 0 },
        { id: 10, name: '41~50', sizeMin: 41, sizeMax: 50, weight: 0 },
        { id: 11, name: '51~58', sizeMin: 51, sizeMax: 58, weight: 0 },
      ],
      _lang: [],
      keywords: '',
    };
  },
  components: {
    selectSort,
  },
  created() {
    this.allDataEn = {
      code: 100,
      data: {
        pageNum: 1,
        pageSize: 505,
        size: 505,
        orderBy: null,
        startRow: 0,
        endRow: 0,
        total: 505,
        pages: 1,
        list: [
          {
            id: 1,
            name: '仓储',
            ename: 'Storage',
            fname: '倉儲',
            arr: [
              {
                id: 550,
                name: 'Warehouse - Shipping label',
                description: null,
                file: 'ddl-en/Warehouse - Shipping label.ddl',
                img: require('@/assets/img-en/Warehouse-Shippinglabel.jpg'),
                fileWidth: 40,
                fileHeight: 30,
                templateBackgroundId: null,
                downloadcount: 49917,
                createTime: 1542200700000,
                templateBackground: null,
              },
              {
                id: 550,
                name: 'Warehouse - Cargo labels',
                description: null,
                file: 'ddl-en/Warehouse - Cargo labels.ddl',
                img: require('@/assets/img-en/Warehouse-Cargolabels.jpg'),
                fileWidth: 50,
                fileHeight: 40,
                templateBackgroundId: null,
                downloadcount: 49917,
                createTime: 1542200700000,
                templateBackground: null,
              }
            ],
          },
          {
            id: 2,
            name: '服装',
            ename: 'Clothing',
            fname: '服裝',
            arr: [
              {
                id: 560,
                name: 'Clothing - Underwear style',
                description: 'null',
                file: 'ddl-en/Clothing - Underwear style.ddl',
                img: require('@/assets/img-en/Clothing-Underwearstyle.jpg'),
                fileWidth: 30,
                fileHeight: 20,
                templateBackgroundId: null,
                downloadcount: 137542,
                createTime: 1542201480000,
                templateBackground: null,
              },

              {
                id: 565,
                name: 'Clothing - Skirt',
                description: 'null',
                file: 'ddl-en/Clothing - Skirt.ddl',
                img: require('@/assets/img-en/Clothing-Skirt.jpg'),
                fileWidth: 40,
                fileHeight: 60,
                templateBackgroundId: null,
                downloadcount: 21168,
                createTime: 1542201840000,
                templateBackground: null,
              },
              {
                id: 567,
                name: 'Clothing - Down jacket',
                description: 'null',
                file: 'ddl-en/Clothing - Down jacket.ddl',
                img: require('@/assets/img-en/Clothing-Downjacket.jpg'),
                fileWidth: 50,
                fileHeight: 90,
                templateBackgroundId: null,
                downloadcount: 9058,
                createTime: 1542201900000,
                templateBackground: null,
              },
            ],
          },
          {
            id: 3,
            name: '电力',
            ename: 'Power',
            fname: '電力',
            arr: [
              {
                id: 758,
                name: 'Electricity - All Copper Core Cable',
                description: null,
                file: 'ddl-en/Electricity - All Copper Core Cable.ddl',
                img: require('@/assets/img-en/Electricity-AllCopperCoreCable.jpg'),
                fileWidth: 30,
                fileHeight: 20,
                templateBackgroundId: null,
                downloadcount: 1382,
                createTime: 1563284880000,
                templateBackground: null,
              },
              {
                id: 758,
                name: 'Electricity - Power Cable',
                description: null,
                file: 'ddl-en/Electricity - Power Cable.ddl',
                img: require('@/assets/img-en/Electricity-PowerCable.jpg'),
                fileWidth: 38,
                fileHeight: 55,
                templateBackgroundId: null,
                downloadcount: 1382,
                createTime: 1563284880000,
                templateBackground: null,
              },
              {
                id: 758,
                name: 'Electricity - Cable Label',
                description: null,
                file: 'ddl-en/Electricity - Cable Label.ddl',
                img: require('@/assets/img-en/Electricity-CableLabel.jpg'),
                fileWidth: 45,
                fileHeight: 70,
                templateBackgroundId: null,
                downloadcount: 1382,
                createTime: 1563284880000,
                templateBackground: null,
              }
            ],
          },
          {
            id: 4,
            name: '电器',
            ename: 'Appliance',
            fname: '電器',
            arr: [
              {
                id: 697,
                name: 'Electrical appliances-product product barcode identification',
                description: null,
                file: 'ddl-en/Electrical appliances-product product barcode identification.ddl',
                img: require('@/assets/img-en/Electricalappliances-productproductbarcodeidentification.jpg'),
                fileWidth: 30,
                fileHeight: 20,
                templateBackgroundId: null,
                downloadcount: 329,
                createTime: 1563282900000,
                templateBackground: null,
              },
              {
                id: 704,
                name: 'Electrical appliances-Motors',
                description: null,
                file: 'ddl-en/Electrical appliances-Motors.ddl',
                img: require('@/assets/img-en/Electricalappliances-Motors.jpg'),
                fileWidth: 50,
                fileHeight: 70,
                templateBackgroundId: null,
                downloadcount: 229,
                createTime: 1563283200000,
                templateBackground: null,
              },
            ],
          },

          {
            id: 5,
            name: '零售',
            ename: 'Retail',
            fname: '零售',
            arr: [
              {
                id: 543,
                name: 'Retail-Mug',
                description: '',
                file: 'ddl-en/Retail-Mug.ddl',
                img: require('@/assets/img-en/Retail-Mug.jpg'),
                fileWidth: 25,
                fileHeight: 15,
                templateBackgroundId: null,
                downloadcount: 768555,
                createTime: 1542200280000,
                templateBackground: null,
              },

              {
                id: 582,
                name: 'Retail-Label Printer',
                description: null,
                file: 'ddl-en/Retail-Label Printer.ddl',
                img: require('@/assets/img-en/Retail-LabelPrinter.jpg'),
                fileWidth: 40,
                fileHeight: 30,
                templateBackgroundId: null,
                downloadcount: 20556,
                createTime: 1542202680000,
                templateBackground: null,
              },
              {
                id: 579,
                name: 'Retail-Qualified  certificate',
                description: null,
                file: 'ddl-en/Retail-Qualified  certificate.ddl',
                img: require('@/assets/img-en/Retail-Qualifiedcertificate.jpg'),
                fileWidth: 45,
                fileHeight: 45,
                templateBackgroundId: null,
                downloadcount: 5724,
                createTime: 1542202440000,
                templateBackground: null,
              }
            ],
          },
          {
            id: 6,
            name: '商超',
            ename: 'Supermarke',
            fname: '商超',
            arr: [
              {
                id: 572,
                name: 'Supermarket - Buy more food',
                description: null,
                file: 'ddl-en/Supermarket - Buy more food.ddl',
                img: require('@/assets/img-en/Supermarket-Buymorefood.jpg'),
                fileWidth: 40,
                fileHeight: 30,
                templateBackgroundId: null,
                downloadcount: 20751,
                createTime: 1542202080000,
                templateBackground: null,
              },
              {
                id: 572,
                name: 'Supermarket -Thermal',
                description: null,
                file: 'ddl-en/Supermarket -Thermal.ddl',
                img: require('@/assets/img-en/Supermarket-Thermal.jpg'),
                fileWidth: 50,
                fileHeight: 35,
                templateBackgroundId: null,
                downloadcount: 20751,
                createTime: 1542202080000,
                templateBackground: null,
              }
            ],
          },

          {
            id: 7,
            name: '食品',
            ename: 'Food',
            fname: '食品',
            arr: [
              {
                id: 544,
                name: 'Catering - Truffle milk tea double row',
                description: 'null',
                file: 'ddl-en/Catering - Truffle milk tea double row.ddl',
                img: require('@/assets/img-en/Catering-Trufflemilkteadoublerow.jpg'),
                fileWidth: 20,
                fileHeight: 10,
                templateBackgroundId: null,
                downloadcount: 257502,
                createTime: 1542200460000,
                templateBackground: null,
              },
              {
                id: 602,
                name: 'Food - Gabor label',
                description: null,
                file: 'ddl-en/Food - Gabor label.ddl',
                img: require('@/assets/img-en/Food-Gaborlabel.jpg'),
                fileWidth: 40,
                fileHeight: 60,
                templateBackgroundId: null,
                downloadcount: 9586,
                createTime: 1544148480000,
                templateBackground: null,
              }
            ],
          },
          {
            id: 8,
            name: '医药',
            ename: 'Medicine',
            fname: '醫藥',
            arr: [
              {
                id: 811,
                name: 'Medicine-Cassia Seed',
                description: null,
                file: 'ddl-en/Medicine-Cassia Seed.ddl',
                img: require('@/assets/img-en/Medicine-CassiaSeed.jpg'),
                fileWidth: 40,
                fileHeight: 30,
                templateBackgroundId: null,
                downloadcount: 585,
                createTime: 1568969220000,
                templateBackground: null,
              },
              {
                id: 811,
                name: 'Medicine',
                description: null,
                file: 'ddl-en/Medicine.ddl',
                img: require('@/assets/img-en/Medicine.jpg'),
                fileWidth: 50,
                fileHeight: 35,
                templateBackgroundId: null,
                downloadcount: 585,
                createTime: 1568969220000,
                templateBackground: null,
              },
            ],
          },
          {
            id: 9,
            name: '珠宝',
            ename: 'Jewellery',
            fname: '珠寶',
            arr: [
              {
                id: 589,
                name: 'Jewelry - Turquoise label',
                description: 'null',
                file: 'ddl-en/Jewelry - Turquoise label.ddl',
                img: require('@/assets/img-en/Jewelry-Turquoiselabel.jpg'),
                fileWidth: 30,
                fileHeight: 70,
                templateBackgroundId: null,
                downloadcount: 10664,
                createTime: 1542203220000,
                templateBackground: null,
              },
              {
                id: 589,
                name: 'Jewelry - Jewelry',
                description: 'null',
                file: 'ddl-en/Jewelry - Jewelry.ddl',
                img: require('@/assets/img-en/Jewelry-Jewelry.jpg'),
                fileWidth: 40,
                fileHeight: 30,
                templateBackgroundId: null,
                downloadcount: 10664,
                createTime: 1542203220000,
                templateBackground: null,
              },
              {
                id: 589,
                name: 'Jewelry',
                description: 'null',
                file: 'ddl-en/Jewelry.ddl',
                img: require('@/assets/img-en/Jewelry.jpg'),
                fileWidth: 50,
                fileHeight: 15,
                templateBackgroundId: null,
                downloadcount: 10664,
                createTime: 1542203220000,
                templateBackground: null,
              }
            ],
          },
          {
            id: 10,
            name: '生产',
            ename: 'Production',
            fname: '生產',
            arr: [
              {
                id: 589,
                name: 'Production-Lathe Blade',
                description: 'null',
                file: 'ddl-en/Production-Lathe Blade.ddl',
                img: require('@/assets/img-en/Production-LatheBlade.jpg'),
                fileWidth: 30,
                fileHeight: 70,
                templateBackgroundId: null,
                downloadcount: 10664,
                createTime: 1542203220000,
                templateBackground: null,
              },
              {
                id: 589,
                name: 'Production-Apparel Certificate',
                description: 'null',
                file: 'ddl-en/Production-Apparel Certificate.ddl',
                img: require('@/assets/img-en/Production-ApparelCertificate.jpg'),
                fileWidth: 40,
                fileHeight: 40,
                templateBackgroundId: null,
                downloadcount: 10664,
                createTime: 1542203220000,
                templateBackground: null,
              },
              {
                id: 589,
                name: 'Production-mobile phone label',
                description: 'null',
                file: 'ddl-en/Production-mobile phone label.ddl',
                img: require('@/assets/img-en/Production-mobilephonelabel.jpg'),
                fileWidth: 50,
                fileHeight: 70,
                templateBackgroundId: null,
                downloadcount: 10664,
                createTime: 1542203220000,
                templateBackground: null,
              }
            ],
          },
          {
            id: 11,
            name: '小票',
            ename: 'SmallTicket',
            fname: '小票',
            arr: [
              {
                id: 589,
                name: 'Clothing receipt',
                description: 'null',
                file: 'ddl-en/Clothing receipt.ddl',
                img: require('@/assets/img-en/Clothingreceipt.jpg'),
                fileWidth: 48,
                fileHeight: 130,
                templateBackgroundId: null,
                downloadcount: 10664,
                createTime: 1542203220000,
                templateBackground: null,
              },
              {
                id: 589,
                name: 'Dining Receipt',
                description: 'null',
                file: 'ddl-en/Dining Receipt.ddl',
                img: require('@/assets/img-en/DiningReceipt.jpg'),
                fileWidth: 58,
                fileHeight: 130,
                templateBackgroundId: null,
                downloadcount: 10664,
                createTime: 1542203220000,
                templateBackground: null,
              }
            ],
          },
          {
            id: 12,
            name: '物流',
            ename: 'Logistics',
            fname: '物流',
            arr: [
              {
                id: 589,
                name: 'Logistics - Warehouse transport double',
                description: 'null',
                file: 'ddl-en/Logistics - Warehouse transport double.ddl',
                img: require('@/assets/img-en/Logistics-Warehousetransportdouble.jpg'),
                fileWidth: 20,
                fileHeight: 20,
                templateBackgroundId: null,
                downloadcount: 10664,
                createTime: 1542203220000,
                templateBackground: null,
              },
              {
                id: 589,
                name: 'Logistics - Courier station',
                description: 'null',
                file: 'ddl-en/Logistics - Courier station.ddl',
                img: require('@/assets/img-en/Logistics-Courierstation.jpg'),
                fileWidth: 40,
                fileHeight: 30,
                templateBackgroundId: null,
                downloadcount: 10664,
                createTime: 1542203220000,
                templateBackground: null,
              },
              {
                id: 589,
                name: 'Logistics - Warehouse express freight label',
                description: 'null',
                file: 'ddl-en/Logistics - Warehouse express freight label.ddl',
                img: require('@/assets/img-en/Logistics-Warehouseexpressfreightlabel.jpg'),
                fileWidth: 50,
                fileHeight: 40,
                templateBackgroundId: null,
                downloadcount: 10664,
                createTime: 1542203220000,
                templateBackground: null,
              },
              {
                id: 589,
                name: 'Logistics - Waybills',
                description: 'null',
                file: 'ddl-en/Logistics - Waybills.ddl',
                img: require('@/assets/img-en/Logistics-Waybills.jpg'),
                fileWidth: 58,
                fileHeight: 40,
                templateBackgroundId: null,
                downloadcount: 10664,
                createTime: 1542203220000,
                templateBackground: null,
              },
            ],
          },
          {
            id: 13,
            name: '资产',
            ename: 'Assets',
            fname: '資產',
            arr: [
              {
                id: 589,
                name: 'Assets - iPhone label',
                description: 'null',
                file: 'ddl-en/Assets - iPhone label.ddl',
                img: require('@/assets/img-en/Assets-iPhonelabel.jpg'),
                fileWidth: 40,
                fileHeight: 30,
                templateBackgroundId: null,
                downloadcount: 10664,
                createTime: 1542203220000,
                templateBackground: null,
              },
              {
                id: 589,
                name: 'Assets-Exam room label',
                description: 'null',
                file: 'ddl-en/Assets-Exam room label.ddl',
                img: require('@/assets/img-en/Assets-Examroomlabel.jpg'),
                fileWidth: 50,
                fileHeight: 20,
                templateBackgroundId: null,
                downloadcount: 10664,
                createTime: 1542203220000,
                templateBackground: null,
              }
            ],
          },
          {
            id: 14,
            name: '家装',
            ename: 'homeDecoration',
            fname: '家裝',
            arr: [
              {
                id: 589,
                name: 'Home-black gold flower marble',
                description: 'null',
                file: 'ddl-en/Home-black gold flower marble.ddl',
                img: require('@/assets/img-en/Home-blackgoldflowermarble.jpg'),
                fileWidth: 30,
                fileHeight: 70,
                templateBackgroundId: null,
                downloadcount: 10664,
                createTime: 1542203220000,
                templateBackground: null,
              },
              {
                id: 589,
                name: 'Home-paint label',
                description: 'null',
                file: 'ddl-en/Home-paint label.ddl',
                img: require('@/assets/img-en/Home-paintlabel.jpg'),
                fileWidth: 50,
                fileHeight: 80,
                templateBackgroundId: null,
                downloadcount: 10664,
                createTime: 1542203220000,
                templateBackground: null,
              },
            ],
          },
        ],

        firstPage: 1,
        prePage: 0,
        nextPage: 0,
        lastPage: 1,
        isFirstPage: true,
        isLastPage: true,
        hasPreviousPage: false,
        hasNextPage: false,
        navigatePages: 8,
        navigatepageNums: [1],
      },
      message: '成功',
      attachment: null,
    };
    this.allDataZh = {
      code: 100,
      data: {
        pageNum: 1,
        pageSize: 505,
        size: 505,
        orderBy: null,
        startRow: 0,
        endRow: 0,
        total: 505,
        pages: 1,
        list: [
          {
            id: 1,
            name: '仓储',
            ename: 'Storage',
            fname: '倉儲',
            arr: [
              {
                id: 550,
                name: '仓储-发货标签',
                description: null,
                file: 'ddl-zh/仓储-发货标签.ddl',
                img: require('@/assets/img-zh/仓储-发货标签.jpg'),
                fileWidth: 40,
                fileHeight: 30,
                templateBackgroundId: null,
                downloadcount: 49917,
                createTime: 1542200700000,
                templateBackground: null,
              },
              {
                id: 550,
                name: '仓储-货物标签',
                description: null,
                file: 'ddl-zh/仓储-货物标签.ddl',
                img: require('@/assets/img-zh/仓储-货物标签.jpg'),
                fileWidth: 50,
                fileHeight: 40,
                templateBackgroundId: null,
                downloadcount: 49917,
                createTime: 1542200700000,
                templateBackground: null,
              },
            ],
          },
          {
            id: 2,
            name: '服装',
            ename: 'Clothing',
            fname: '服裝',
            arr: [
              {
                id: 560,
                name: '服装-文胸款式',
                description: 'null',
                file: 'ddl-zh/服装-文胸款式.ddl',
                img: require('@/assets/img-zh/服装-文胸款式.jpg'),
                fileWidth: 30,
                fileHeight: 20,
                templateBackgroundId: null,
                downloadcount: 137542,
                createTime: 1542201480000,
                templateBackground: null,
              },

              {
                id: 565,
                name: '服装-裙子',
                description: 'null',
                file: 'ddl-zh/服装-裙子.ddl',
                img: require('@/assets/img-zh/服装-裙子.jpg'),
                fileWidth: 40,
                fileHeight: 60,
                templateBackgroundId: null,
                downloadcount: 21168,
                createTime: 1542201840000,
                templateBackground: null,
              },
              {
                id: 567,
                name: '服装-羽绒服',
                description: 'null',
                file: 'ddl-zh/服装-羽绒服.ddl',
                img: require('@/assets/img-zh/服装-羽绒服.jpg'),
                fileWidth: 50,
                fileHeight: 90,
                templateBackgroundId: null,
                downloadcount: 9058,
                createTime: 1542201900000,
                templateBackground: null,
              },
            ],
          },
          {
            id: 3,
            name: '电力',
            ename: 'Power',
            fname: '電力',
            arr: [
              {
                id: 758,
                name: '电力-全铜芯电缆',
                description: null,
                file: 'ddl-zh/电力-全铜芯电缆.ddl',
                img: require('@/assets/img-zh/电力-全铜芯电缆.jpg'),
                fileWidth: 30,
                fileHeight: 20,
                templateBackgroundId: null,
                downloadcount: 1382,
                createTime: 1563284880000,
                templateBackground: null,
              },
              {
                id: 758,
                name: '电力-电力线缆',
                description: null,
                file: 'ddl-zh/电力-电力线缆.ddl',
                img: require('@/assets/img-zh/电力-电力线缆.jpg'),
                fileWidth: 38,
                fileHeight: 55,
                templateBackgroundId: null,
                downloadcount: 1382,
                createTime: 1563284880000,
                templateBackground: null,
              },
              {
                id: 758,
                name: '电力-电缆标签',
                description: null,
                file: 'ddl-zh/电力-电缆标签.ddl',
                img: require('@/assets/img-zh/电力-电缆标签.jpg'),
                fileWidth: 45,
                fileHeight: 70,
                templateBackgroundId: null,
                downloadcount: 1382,
                createTime: 1563284880000,
                templateBackground: null,
              },
            ],
          },
          {
            id: 4,
            name: '电器',
            ename: 'Appliance',
            fname: '電器',
            arr: [
              {
                id: 697,
                name: '电器-产品商品条码标识',
                description: null,
                file: 'ddl-zh/电器-产品商品条码标识.ddl',
                img: require('@/assets/img-zh/电器-产品商品条码标识.jpg'),
                fileWidth: 30,
                fileHeight: 20,
                templateBackgroundId: null,
                downloadcount: 329,
                createTime: 1563282900000,
                templateBackground: null,
              },
              {
                id: 704,
                name: '电器-电机',
                description: null,
                file: 'ddl-zh/电器-电机.ddl',
                img: require('@/assets/img-zh/电器-电机.jpg'),
                fileWidth: 50,
                fileHeight: 70,
                templateBackgroundId: null,
                downloadcount: 229,
                createTime: 1563283200000,
                templateBackground: null,
              },
            ],
          },

          {
            id: 5,
            name: '零售',
            ename: 'Retail',
            fname: '零售',
            arr: [
              {
                id: 543,
                name: '零售-马克杯',
                description: '',
                file: 'ddl-zh/零售-马克杯.ddl',
                img: require('@/assets/img-zh/零售-马克杯.jpg'),
                fileWidth: 25,
                fileHeight: 15,
                templateBackgroundId: null,
                downloadcount: 768555,
                createTime: 1542200280000,
                templateBackground: null,
              },

              {
                id: 582,
                name: '零售-标签打印机',
                description: null,
                file: 'ddl-zh/零售-标签打印机.ddl',
                img: require('@/assets/img-zh/零售-标签打印机.jpg'),
                fileWidth: 40,
                fileHeight: 30,
                templateBackgroundId: null,
                downloadcount: 20556,
                createTime: 1542202680000,
                templateBackground: null,
              },
              {
                id: 579,
                name: '零售-合格证',
                description: null,
                file: 'ddl-zh/零售-合格证.ddl',
                img: require('@/assets/img-zh/零售-合格证.jpg'),
                fileWidth: 45,
                fileHeight: 45,
                templateBackgroundId: null,
                downloadcount: 5724,
                createTime: 1542202440000,
                templateBackground: null,
              },
            ],
          },
          {
            id: 6,
            name: '商超',
            ename: 'Supermarke',
            fname: '商超',
            arr: [
              {
                id: 572,
                name: '商超-多多买菜',
                description: null,
                file: 'ddl-zh/商超-多多买菜.ddl',
                img: require('@/assets/img-zh/商超-多多买菜.jpg'),
                fileWidth: 40,
                fileHeight: 30,
                templateBackgroundId: null,
                downloadcount: 20751,
                createTime: 1542202080000,
                templateBackground: null,
              },
              {
                id: 572,
                name: '商超-热敏',
                description: null,
                file: 'ddl-zh/商超-热敏.ddl',
                img: require('@/assets/img-zh/商超-热敏.jpg'),
                fileWidth: 50,
                fileHeight: 35,
                templateBackgroundId: null,
                downloadcount: 20751,
                createTime: 1542202080000,
                templateBackground: null,
              },
            ],
          },

          {
            id: 7,
            name: '食品',
            ename: 'Food',
            fname: '食品',
            arr: [
              {
                id: 544,
                name: '餐饮-松露奶茶双排',
                description: 'null',
                file: 'ddl-zh/餐饮-松露奶茶双排.ddl',
                img: require('@/assets/img-zh/餐饮-松露奶茶双排.jpg'),
                fileWidth: 20,
                fileHeight: 10,
                templateBackgroundId: null,
                downloadcount: 257502,
                createTime: 1542200460000,
                templateBackground: null,
              },
              {
                id: 544,
                name: '食品-佳宝标签',
                description: 'null',
                file: 'ddl-zh/食品-佳宝标签.ddl',
                img: require('@/assets/img-zh/食品-佳宝标签.jpg'),
                fileWidth: 40,
                fileHeight: 60,
                templateBackgroundId: null,
                downloadcount: 257502,
                createTime: 1542200460000,
                templateBackground: null,
              },
            ],
          },
          {
            id: 8,
            name: '医药',
            ename: 'Medicine',
            fname: '醫藥',
            arr: [
              {
                id: 811,
                name: '医药-决明子',
                description: null,
                file: 'ddl-zh/医药-决明子.ddl',
                img: require('@/assets/img-zh/医药-决明子.jpg'),
                fileWidth: 40,
                fileHeight: 30,
                templateBackgroundId: null,
                downloadcount: 585,
                createTime: 1568969220000,
                templateBackground: null,
              },
              {
                id: 811,
                name: '医药',
                description: null,
                file: 'ddl-zh/yiyao.ddl',
                img: require('@/assets/img-zh/yiyao.jpg'),
                fileWidth: 50,
                fileHeight: 35,
                templateBackgroundId: null,
                downloadcount: 585,
                createTime: 1568969220000,
                templateBackground: null,
              },
            ],
          },
          {
            id: 9,
            name: '珠宝',
            ename: 'Jewellery',
            fname: '珠寶',
            arr: [
              {
                id: 589,
                name: '珠宝-绿松石标签',
                description: 'null',
                file: 'ddl-zh/珠宝-绿松石标签.ddl',
                img: require('@/assets/img-zh/珠宝-绿松石标签.jpg'),
                fileWidth: 30,
                fileHeight: 70,
                templateBackgroundId: null,
                downloadcount: 10664,
                createTime: 1542203220000,
                templateBackground: null,
              },
              {
                id: 589,
                name: '珠宝-首饰',
                description: 'null',
                file: 'ddl-zh/珠宝-首饰.ddl',
                img: require('@/assets/img-zh/珠宝-首饰.jpg'),
                fileWidth: 40,
                fileHeight: 30,
                templateBackgroundId: null,
                downloadcount: 10664,
                createTime: 1542203220000,
                templateBackground: null,
              },
              {
                id: 589,
                name: '珠宝',
                description: 'null',
                file: 'ddl-zh/珠宝.ddl',
                img: require('@/assets/img-zh/珠宝.jpg'),
                fileWidth: 50,
                fileHeight: 15,
                templateBackgroundId: null,
                downloadcount: 10664,
                createTime: 1542203220000,
                templateBackground: null,
              },
            ],
          },
          {
            id: 10,
            name: '生产',
            ename: 'Production',
            fname: '生產',
            arr: [
              {
                id: 589,
                name: '生产-车床刀片',
                description: 'null',
                file: 'ddl-zh/生产-车床刀片.ddl',
                img: require('@/assets/img-zh/生产-车床刀片.jpg'),
                fileWidth: 30,
                fileHeight: 15,
                templateBackgroundId: null,
                downloadcount: 10664,
                createTime: 1542203220000,
                templateBackground: null,
              },
              {
                id: 589,
                name: '生产-服装合格证',
                description: 'null',
                file: 'ddl-zh/生产-服装合格证.ddl',
                img: require('@/assets/img-zh/生产-服装合格证.jpg'),
                fileWidth: 40,
                fileHeight: 40,
                templateBackgroundId: null,
                downloadcount: 10664,
                createTime: 1542203220000,
                templateBackground: null,
              },
              {
                id: 589,
                name: '生产-手机标签',
                description: 'null',
                file: 'ddl-zh/生产-手机标签.ddl',
                img: require('@/assets/img-zh/生产-手机标签.jpg'),
                fileWidth: 50,
                fileHeight: 70,
                templateBackgroundId: null,
                downloadcount: 10664,
                createTime: 1542203220000,
                templateBackground: null,
              },
            ],
          },
          {
            id: 11,
            name: '小票',
            ename: 'SmallTicket',
            fname: '小票',
            arr: [
              {
                id: 589,
                name: '服装小票',
                description: 'null',
                file: 'ddl-zh/服装小票.ddl',
                img: require('@/assets/img-zh/服装小票.jpg'),
                fileWidth: 48,
                fileHeight: 130,
                templateBackgroundId: null,
                downloadcount: 10664,
                createTime: 1542203220000,
                templateBackground: null,
              },
              {
                id: 589,
                name: '餐饮小票',
                description: 'null',
                file: 'ddl-zh/餐饮小票.ddl',
                img: require('@/assets/img-zh/餐饮小票.jpg'),
                fileWidth: 58,
                fileHeight: 130,
                templateBackgroundId: null,
                downloadcount: 10664,
                createTime: 1542203220000,
                templateBackground: null,
              },
            ],
          },
          {
            id: 12,
            name: '物流',
            ename: 'Logistics',
            fname: '物流',
            arr: [
              {
                id: 589,
                name: '物流-仓库运输双排',
                description: 'null',
                file: 'ddl-zh/物流-仓库运输双排.ddl',
                img: require('@/assets/img-zh/物流-仓库运输双排.jpg'),
                fileWidth: 20,
                fileHeight: 20,
                templateBackgroundId: null,
                downloadcount: 10664,
                createTime: 1542203220000,
                templateBackground: null,
              },
              {
                id: 589,
                name: '物流-快递驿站',
                description: 'null',
                file: 'ddl-zh/物流-快递驿站.ddl',
                img: require('@/assets/img-zh/物流-快递驿站.jpg'),
                fileWidth: 40,
                fileHeight: 40,
                templateBackgroundId: null,
                downloadcount: 10664,
                createTime: 1542203220000,
                templateBackground: null,
              },
              {
                id: 589,
                name: '物流-仓储快递货运标签',
                description: 'null',
                file: 'ddl-zh/物流-仓储快递货运标签.ddl',
                img: require('@/assets/img-zh/物流-仓储快递货运标签.jpg'),
                fileWidth: 50,
                fileHeight: 40,
                templateBackgroundId: null,
                downloadcount: 10664,
                createTime: 1542203220000,
                templateBackground: null,
              },
              {
                id: 589,
                name: '物流-运单',
                description: 'null',
                file: 'ddl-zh/物流-运单.ddl',
                img: require('@/assets/img-zh/物流-运单.jpg'),
                fileWidth: 58,
                fileHeight: 40,
                templateBackgroundId: null,
                downloadcount: 10664,
                createTime: 1542203220000,
                templateBackground: null,
              },
            ],
          },
          {
            id: 13,
            name: '资产',
            ename: 'Assets',
            fname: '資產',
            arr: [
              {
                id: 589,
                name: '资产-苹果手机标签',
                description: 'null',
                file: 'ddl-zh/资产-苹果手机标签.ddl',
                img: require('@/assets/img-zh/资产-苹果手机标签.jpg'),
                fileWidth: 40,
                fileHeight: 30,
                templateBackgroundId: null,
                downloadcount: 10664,
                createTime: 1542203220000,
                templateBackground: null,
              },
              {
                id: 589,
                name: '资产-考场标签',
                description: 'null',
                file: 'ddl-zh/资产-考场标签.ddl',
                img: require('@/assets/img-zh/资产-考场标签.jpg'),
                fileWidth: 50,
                fileHeight: 20,
                templateBackgroundId: null,
                downloadcount: 10664,
                createTime: 1542203220000,
                templateBackground: null,
              },
            ],
          },
          {
            id: 14,
            name: '家装',
            ename: 'homeDecoration',
            fname: '家裝',
            arr: [
              {
                id: 589,
                name: '家装-黑金花大理石',
                description: 'null',
                file: 'ddl-zh/家装-黑金花大理石.ddl',
                img: require('@/assets/img-zh/家装-黑金花大理石.jpg'),
                fileWidth: 40,
                fileHeight: 60,
                templateBackgroundId: null,
                downloadcount: 10664,
                createTime: 1542203220000,
                templateBackground: null,
              },
              {
                id: 589,
                name: '家装-颜料标签',
                description: 'null',
                file: 'ddl-zh/家装-颜料标签.ddl',
                img: require('@/assets/img-zh/家装-颜料标签.jpg'),
                fileWidth: 50,
                fileHeight: 80,
                templateBackgroundId: null,
                downloadcount: 10664,
                createTime: 1542203220000,
                templateBackground: null,
              },
            ],
          },
        ],

        firstPage: 1,
        prePage: 0,
        nextPage: 0,
        lastPage: 1,
        isFirstPage: true,
        isLastPage: true,
        hasPreviousPage: false,
        hasNextPage: false,
        navigatePages: 8,
        navigatepageNums: [1],
      },
      message: '成功',
      attachment: null,
    };
    console.log(this.allData);
    if(this.$route.query.type==1){
      this.allData = this.allDataEn
    }else{
      this.allData = this.allDataZh
    }
    dsBridge.register('searchTemp', (r, l) => {
      this.page = 1;
      this.keywords = r;
      this.getData(this.cateIndex);
    });
    // setTimeout(() => {
    //   this.keywords = '70'
    //   this.getData()
    // }, 2000);
    this._lang = lang;
    this.getCate();
    this.getData(0);
    this.getSize();
    // window.onscroll = () => {
    //   if (
    //     this.getScrollTop() + this.getWindowHeight() >=
    //     this.getScrollHeight() - 500
    //   ) {
    //     this.addData();
    //   }
    // };
  },
  // watch:{
  //   '$route':function(val){
  //     // console.log(val.query.type)
  //     this.page = 1
  //     this._lang = lang;
  //    this.getCate();
  //   this.getData();
  //   this.getSize();
  //   }
  // },
  filters: {
    //转化时间年月日
    partFilter: function (value, type) {
      if (!value) return '';
      var time = value.split('T')[0];
      var year = time.split('-');
      value = year[0] + '-' + year[1] + '-' + year[2].split(' ')[0];
      return value;
    },
  },
  methods: {
    base64_encode(str) {
      var c1, c2, c3;
      var base64EncodeChars =
        'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
      var i = 0,
        len = str.length,
        string = '';
      while (i < len) {
        c1 = str.charCodeAt(i++) & 0xff;
        if (i == len) {
          string += base64EncodeChars.charAt(c1 >> 2);
          string += base64EncodeChars.charAt((c1 & 0x3) << 4);
          string += '==';
          break;
        }
        c2 = str.charCodeAt(i++);
        if (i == len) {
          string += base64EncodeChars.charAt(c1 >> 2);
          string += base64EncodeChars.charAt(
            ((c1 & 0x3) << 4) | ((c2 & 0xf0) >> 4)
          );
          string += base64EncodeChars.charAt((c2 & 0xf) << 2);
          string += '=';
          break;
        }
        c3 = str.charCodeAt(i++);
        string += base64EncodeChars.charAt(c1 >> 2);
        string += base64EncodeChars.charAt(
          ((c1 & 0x3) << 4) | ((c2 & 0xf0) >> 4)
        );
        string += base64EncodeChars.charAt(
          ((c2 & 0xf) << 2) | ((c3 & 0xc0) >> 6)
        );
        string += base64EncodeChars.charAt(c3 & 0x3f);
      }
      return string;
    },
    getEncry(str) {
      let k2 = this.getCode(this.mac); // 对需要加密的数据进行加密
      k2 = this.buf2hex(this.base64ToUint8Array(k2));
      var k3 = this.encrypt(JSON.stringify(str));
      // k3 = this.base64_encode(k3)
      k3 = this.base64ToUint8Array(k3);
      k3 = this.buf2hex(k3);
      var k4 = this.base64_encode('key=' + k2 + '&text=' + k3);
      var k5 = this.stringArrayBuffer(k4);
      var k6 = this.buf2hex(k5);

      let sha256 = jsSha256.sha256; //这里用的是require方法
      var k7 = sha256(k6);
      return k6 + ',' + k7;
    },
    getCode(str) {
      //此处操作与后端约定参数
      // 创建RSAKey对象
      let pubKey = `MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCXRtG/gee0XLO+AGkp3qdI3pkntdB/5ej3DiCD3ZfTv1F1zl37I5ncXIQ9zpK5WEiGTCoVrywclj9etBdecchO2ZMVRT5MBb0EL7FZTdJz93xoAW6ZKbAUS4GBo20aM/7l+3JdX7L/fu/MIvT0GkKoNyTmWCC9VJ8/nKnj4b1uVwIDAQAB`; // ES6 模板字符串 引用 rsa 公钥
      let encryptStr = new JSEncrypt();
      encryptStr.setPublicKey(pubKey); // 设置 加密公钥
      let data = encryptStr.encrypt(str.toString()); // 进行加密
      return data;
    },
    buf2hex(buffer) {
      // buffer is an ArrayBuffer
      return Array.prototype.map
        .call(new Uint8Array(buffer), (x) => ('00' + x.toString(16)).slice(-2))
        .join('');
    },
    stringArrayBuffer(str) {
      const buffer = new ArrayBuffer(str.length);
      const bytes = new Uint8Array(buffer);

      str.split('').forEach(function (str, i) {
        bytes[i] = str.charCodeAt(0);
      });

      return buffer;
    },
    encrypt(plaintText) {
      const CRYPTOJSKEY = 'daf3b950-27ee-4d';
      var plaintText = plaintText;
      var options = {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7,
      };
      var key = CryptoJS.enc.Utf8.parse(CRYPTOJSKEY);
      var encryptedData = CryptoJS.AES.encrypt(plaintText, key, options);
      var encryptedBase64Str = encryptedData.toString().replace(/\//g, '_');
      encryptedBase64Str = encryptedBase64Str.replace(/\+/g, '-');
      return encryptedBase64Str;
    },
    base64ToUint8Array(base64String) {
      const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
      const base64 = (base64String + padding)
        .replace(/\-/g, '+')
        .replace(/_/g, '/');
      const rawData = window.atob(base64);
      const outputArray = new Uint8Array(rawData.length);
      for (let i = 0; i < rawData.length; ++i) {
        outputArray[i] = rawData.charCodeAt(i);
      }
      return outputArray;
    },
    _base64ToArrayBuffer(base64) {
      var binary_string = window.atob(base64);
      var len = binary_string.length;
      var bytes = new Uint8Array(len);
      for (var i = 0; i < len; i++) {
        bytes[i] = binary_string.charCodeAt(i);
      }
      return bytes.buffer;
    },
    selectTag(item) {
      clearTimeout(_tagTime);

      if (this.tagTime) return;
      var _tagTime = setTimeout(() => {
        this.tagTime = false;
      }, 2000);
      this.tagTime = true;
      var width = 0,
        height = 0;
      console.log({
        id: item.id,
        name: item.name,
        width: item.fileWidth,
        file: item.file,
        height: item.fileHeight,
        bgm: item.templateBackground ? item.templateBackground : '',
      });

      dsBridge.call('Dlabel.getTemplate', {
        id: item.id,
        name: item.name,
        width: item.fileWidth,
        file: item.file,
        height: item.fileHeight,
        bgm: item.templateBackground ? item.templateBackground : '',
      });
    },
    getSize() {
      // var tempData = {
      //   equipMeid: GetQueryString('equipMeid'),
      //   equipVersion: GetQueryString('equipVersion'),
      //   model: GetQueryString('model'),
      //   equip: GetQueryString('equip'),
      //   appChannel: GetQueryString('appChannel'),
      //   src: 2,
      //   reqTime: new Date().getTime(),
      //   version: GetQueryString('version'),
      //   macCode:
      //     GetQueryString('macCode') == '(null)' ||
      //     GetQueryString('macCode') == ''
      //       ? ''
      //       : GetQueryString('macCode'),
      // };
      // tempData = this.getEncry(tempData);
      // getFileSize({
      //   mcontext: tempData.split(',')[0],
      //   sign: tempData.split(',')[1],
      // }).then((res) => {
      //   this.sizeData = res.data.data;
      //   //this.sizeData.splice(0, 0, { id: "", name: lang[this.$route.query.type].zhen_26 });
      // });
    },
    getWindowHeight() {
      var windowHeight = 0;
      if (document.compatMode == 'CSS1Compat') {
        windowHeight = document.documentElement.clientHeight;
      } else {
        windowHeight = document.body.clientHeight;
      }
      return windowHeight;
    },
    //获取文档完整的高度
    getScrollHeight() {
      var scrollHeight = 0,
        bodyScrollHeight = 0,
        documentScrollHeight = 0;
      if (document.body) {
        bodyScrollHeight = document.body.scrollHeight;
      }
      if (document.documentElement) {
        documentScrollHeight = document.documentElement.scrollHeight;
      }
      scrollHeight =
        bodyScrollHeight - documentScrollHeight > 0
          ? bodyScrollHeight
          : documentScrollHeight;
      return scrollHeight;
    },
    getScrollTop() {
      var scrollTop = 0,
        bodyScrollTop = 0,
        documentScrollTop = 0;
      if (document.body) {
        bodyScrollTop = document.body.scrollTop;
      }
      if (document.documentElement) {
        documentScrollTop = document.documentElement.scrollTop;
      }
      scrollTop =
        bodyScrollTop - documentScrollTop > 0
          ? bodyScrollTop
          : documentScrollTop;
      return scrollTop;
    },
    getData(index) {
      if (index == 0) {
        var tempData = [];
        this.allData.data.list.forEach((item) => {
          tempData = [...tempData, ...item.arr];
        });

        if (this.keywords.length > 0 || this.sizeIndex > 0) {
          var datas = [];
          if (this.keywords.length > 0) {
            console.log('qqqqq')
            console.log(tempData)
            tempData.forEach((item) => {
              if (
                item.name.indexOf(this.keywords) != -1 ||
                (item.sizeMin + '').indexOf(this.keywords) != -1 ||
                (item.sizeMax + '').indexOf(this.keywords) != -1||
                (item.fileWidth + '').indexOf(this.keywords) != -1 
              ) {
                datas.push(item);
              }
            });
          } else if (this.sizeIndex > 0) {
            tempData.forEach((item) => {
              if (
                item.fileWidth >= this.sizeData[this.sizeIndex - 1].sizeMin &&
                item.fileWidth <= this.sizeData[this.sizeIndex - 1].sizeMax
              ) {
                datas.push(item);
              }
            });
          }

          this.cloudData = datas
        } else {
          this.cloudData = tempData
        }
      } else {
        var tempData = this.allData.data.list[index - 1].arr;
        if (this.keywords.length > 0 || this.sizeIndex > 0) {
          var datas = [];
          if (this.keywords.length > 0) {
            tempData.forEach((item) => {
              if (
                item.name.indexOf(this.keywords) != -1 ||
                (item.sizeMin + '').indexOf(this.keywords) != -1 ||
                (item.sizeMax + '').indexOf(this.keywords) != -1
              ) {
                datas.push(item);
              }
            });
          } else if (this.sizeIndex > 0) {
            tempData.forEach((item) => {
              if (
                item.fileWidth >= this.sizeData[this.sizeIndex - 1].sizeMin &&
                item.fileWidth <= this.sizeData[this.sizeIndex - 1].sizeMax
              ) {
                datas.push(item);
              }
            });
          }

          this.cloudData = datas
        } else {
          this.cloudData = tempData
        }
      }
    },
    addData() {
      if (this.loadingData) {
        return;
      }
      var tempIndex = 0,
        min = '',
        max = '';
      if (this.sizeIndex != 0) {
        tempIndex = this.sizeIndex - 1;
        min = this.sizeData[tempIndex].sizeMin;
        max = this.sizeData[tempIndex].sizeMax;
      }
      this.loadingData = true;
      // this.$indicator.open({
      //   text: "Loading..."
      // });
      var type = this.$route.query.type;
      if (type == 1) {
        type = 2;
      } else {
        type = 1;
      }
      var tempData = {
        templateTypeId:
          this.cateIndex == 0 ? '' : this.cateData[this.cateIndex - 1].id,
        pageNo: this.page,
        pageSize: this.page_size,
        sizeMin: min,
        sizeMax: max,
        equipMeid: GetQueryString('equipMeid'),
        equipVersion: GetQueryString('equipVersion'),
        model: GetQueryString('model'),
        appChannel: GetQueryString('appChannel'),
        src: 2,
        languageId: type,
        equip: GetQueryString('equip'),
        reqTime: new Date().getTime(),
        version: GetQueryString('version'),
        macCode:
          GetQueryString('macCode') == '(null)' ||
          GetQueryString('macCode') == ''
            ? ''
            : GetQueryString('macCode'),
      };
      if (this.keywords.length <= 0) {
        tempData.templateTypeId =
          this.cateIndex == 0 ? '' : this.cateData[this.cateIndex - 1].id;
      } else {
        tempData.keyWords = this.keywords;
      }
      tempData = this.getEncry(tempData);
      DlabelTemplate({
        mcontext: tempData.split(',')[0],
        sign: tempData.split(',')[1],
      })
        .then((res) => {
          this.page++;
          //this.$indicator.close();
          if (
            res.data.data.list.length <= 0 ||
            res.data.data.list.length < this.page_size
          ) {
            this.noData = true;
            this.loadingData = true;
          } else {
            this.loadingData = false;
          }
          res.data.data.list.forEach((element) => {
            this.cloudData.push(element);
          });
        })
        .catch((res) => {
          this.noData = true;
          this.loadingData = true;
          //this.$indicator.close();
        });
    },
    getCate() {
      this.cateData = [
        {
          id: 1,
          name: '仓储',
          ename: 'Storage',
          fname: '倉儲',
        },
        {
          id: 2,
          name: '服装',
          ename: 'Clothing',
          fname: '服裝',
        },
        {
          id: 3,
          name: '电力',
          ename: 'Power',
          fname: '電力',
        },
        {
          id: 4,
          name: '电器',
          ename: 'Appliance',
          fname: '電器',
        },
        {
          id: 5,
          name: '零售',
          ename: 'Retail',
          fname: '零售',
        },
        {
          id: 6,
          name: '商超',
          ename: 'Supermarke',
          fname: '商超',
        },
        {
          id: 7,
          name: '食品',
          ename: 'Food',
          fname: '食品',
        },
        {
          id: 8,
          name: '医药',
          ename: 'Medicine',
          fname: '醫藥',
        },
        {
          id: 9,
          name: '珠宝',
          ename: 'Jewellery',
          fname: '珠寶',
        },
        {
          id: 10,
          name: '生产',
          ename: 'Production',
          fname: '生產',
        },
        {
          id: 11,
          name: '小票',
          ename: 'SmallTicket',
          fname: '小票',
        },
        {
          id: 12,
            name: '物流',
            ename: 'Logistics',
            fname: '物流',
        },
        {
          id: 13,
          name: '资产',
          ename: 'Assets',
          fname: '資產',
        },
        {
          id: 14,
          name: '家装',
          ename: 'homeDecoration',
          fname: '家裝',
        },
      ];
      // var type = this.$route.query.type;
      // if (type == 1) {
      //   type = 2;
      // } else {
      //   type = 1;
      // }

      // var tempData = {
      //   equipMeid: GetQueryString('equipMeid'),
      //   equipVersion: GetQueryString('equipVersion'),
      //   model: GetQueryString('model'),
      //   appChannel: GetQueryString('appChannel'),
      //   languageId: type,
      //   src: 2,
      //   equip: GetQueryString('equip'),
      //   reqTime: new Date().getTime(),
      //   version: GetQueryString('version'),
      //   macCode:
      //     GetQueryString('macCode') == '(null)' ||
      //     GetQueryString('macCode') == ''
      //       ? ''
      //       : GetQueryString('macCode'),
      // };
      // tempData = this.getEncry(tempData);
      // TemplateCategory({
      //   mcontext: tempData.split(',')[0],
      //   sign: tempData.split(',')[1],
      // }).then((res) => {
      //   this.cateData = res.data.data;
      //   // this.cateData.splice(0, 0, { id: "", name: lang[this.$route.query.type].zhen_26 });
      // });
    },
    openSort() {
      this.showSort = true;
    },
    selectCate(index) {
      this.loadingData = false;
      window.scrollTo(0, 0);
      this.cateIndex = index;
      // this.page = 1;
      this.getData(index);
    },
    selectSize(index) {
      window.scrollTo(0, 0);
      this.loadingData = false;
      // this.page = 1;
      this.sizeIndex = index;
      this.getData(this.cateIndex);
    },
  },
};
</script>



